const header = document.querySelector("header");
const heroSectionHeight = document.querySelector("#hero").offsetHeight;

window.addEventListener("scroll", () => {
  if (window.scrollY > 0) {
    header.classList.add("shadow");
    if (window.scrollY > heroSectionHeight) {
      header.classList.add("bg-[#F6F7FF]");
    } else {
      header.classList.remove("bg-[#F6F7FF]");
    }
  } else {
    header.classList.remove("bg-[#F6F7FF]", "shadow");
  }
});
